module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-desktop_dec66187760a481e10a57fbf8ff0368d.webp";